import React from "react";
import { useParams } from "react-router";
import Retool from ".";
import FullScreenLayout from "layouts/MainLayout/FullScreenLayout";
import { buildingStore } from "store/Building/BuildingStore";
import { useTranslation } from "react-i18next";
import { operationalEmissionsStore } from "features/OperationalEmissions/OperationalEmissionsStore";
import useToast from "hooks/useToast";

const EmissionsFromOperation = () => {
  const reportID = "0283ac68-30a7-11f0-ab70-4320fbf49704";
  const { id: BuildingId } = useParams();
  const { t } = useTranslation();
  const toast = useToast();

  const embeddedData = {
    building_id: BuildingId,
  };

  const handleClose = async () => {
    await operationalEmissionsStore
      .fetchSyncB6()
      .then(() => toast(t("operationalEnergy.saveSuccessMessage"), "success"))
      .catch((error) =>
        toast(
          t("operationalEnergy.saveErrorMessage", {
            error: error.status,
          }),
          "warning"
        )
      );
  };

  return (
    <FullScreenLayout
      title={t("buildingPassport.emissionsFromOperation")}
      buildingName={buildingStore.currentBuilding?.name}
      closeButtonTitle={t("commons.saveAndClose")}
      closeButtonAction={handleClose}
      cancelButton
      headerClassName="!hidden"
    >
      <Retool url={reportID} embeddedData={embeddedData} className="h-screen" />
    </FullScreenLayout>
  );
};

export default EmissionsFromOperation;
